module.exports = __webpack_public_path__ + "images/emoji/bridge_at_night.73740b357a11202c3fe3.png";